import styled from 'styled-components';

export const OutlinedCard = styled.div`
  border: ${({ theme }) => theme.border.width.thinner}
    ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.color.border.neutral.default};
  padding: ${({ theme }) => theme.spacing.km10};
  border-radius: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km3};
  }
`;
